




















import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";

@Component
export default class LoginView extends Mixins() {
  data(): any {
    return {
      isAuthenticating: false,
      id: null,
      password: null,
    };
  }
  isAuthenticating: boolean;
  id: string;
  password: string;

  $refs!: {
    password: HTMLInputElement,
  };

  authenticate(): void {
    if (this.isAuthenticating) { return; }
    const service = DomainRegistry.authentication.getAuthenticationService();
    service.login(this.id, this.password)
      .then(() => {
        this.handleAuthenticationSucceeded();
      })
      .catch(e => {
        this.handleAuthenticationFailed(
          e,
          "ログイン失敗",
          "ログイン失敗しました。ログインIDとパスワードを確認してください。",
        );
      }
    );
  }

  private async handleAuthenticationSucceeded(): Promise<void> {
    const destination = this.queryParameterToFirstString(this.$route.query.redirect);
    this.$router.replace(destination ? destination : "/");
  }

  private queryParameterToFirstString(value: string | (string | null)[]): string {
    return Array.isArray(value)
      ? ((0 < value.length) ? value[0] : null)
      : value;
  }

  private handleAuthenticationFailed(error: Error, title: string, message: string): void {
    console.warn(error);
    this.password = "";
    this.$warn(
      title,
      message,
    );
  }

  focusToPassword(): void {
    this.$refs.password.focus();
  }
}
